import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SubscriberState } from './subscriber.state';

export const selectSubscriber = createFeatureSelector<SubscriberState>('subscriber');
